import React, { 
   useEffect, 
   useState , 
   Component 
} from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Collapse,
} from "reactstrap";

import {content} from './content';
import Header from '../../components/header';

const PrivacyPolicy = (props) => {

  return (
      <>
      <section className="bg-half-100 bg-light d-table w-100">
           <Header header={'Privacy Policy'}/>
          <Container className="w-75">
          <Row>
            <Col xs="3">
            </Col>
            <Col xs="9">
                <div dangerouslySetInnerHTML={{ __html: content }}/>
            </Col>
          </Row>
          </Container>
      </section>
      </>
  )
};

export default PrivacyPolicy;
